import type { Components, Theme } from "@mui/material/styles";

export const MuiToolbar: Components<Theme>["MuiToolbar"] = {
  styleOverrides: {
    root: {
      // need to negate the Tabs bottom margin used for indicator offset
      "& .MuiTabs-root": {
        marginBottom: 0,
      },
    },
    regular: ({ theme }) => ({
      height: theme.spacing(7.5),
      padding: theme.spacing(0, 5),
      "@media (min-width: 0px)": {
        minHeight: "unset",
        padding: theme.spacing(0, 5),
      },
    }),
  },
};
